
namespace Matrix.Dashboards {

    export const paramValuesSuffix = "__ParamValues";
    export const paramsOnWidgetSuffix = "__ParamsOnWidget";
    export const paramBindingsSuffix = "__ParamBindings";

    export class WidgetDesignerDialogOptions {
        widgetTypeItem: WidgetTypeItem;
        propertyItems?: Serenity.PropertyItem[];
        data?: any;
        designer?: IWidgetDesigner;
        getBindingKeys?: () => string[];
    }

    export class WidgetDesignerDialog extends Serenity.PropertyDialog<any, WidgetDesignerDialogOptions> implements IWidgetDesignerDialog {

        constructor(opt: WidgetDesignerDialogOptions) {
            super(opt);

            this.dialogTitle = "Edit Options: " + this.options.widgetTypeItem?.Name;

            if (this.options.designer != null)
                this.options.designer.init(this);

            if (this.options.data != null)
                this.propertyGrid.load(this.options.data);

            this.propertyGrid.enumerateItems((item, widget) => {
                if (item.editorType == "ServiceLookup" &&
                    item.editorParams.service == DatasetService.Methods.List) {
                    var editor = Q.safeCast(widget, Serenity.ServiceLookupEditor) as Serenity.ServiceLookupEditor;
                    if (editor) {
                        editor.changeSelect2(() => {
                            this.initParameterProps(item.name);
                        });
                    }
                    this.initParameterProps(item.name,
                        (this.options.data || {})[item.name + paramValuesSuffix],
                        (this.options.data || {})[item.name + paramsOnWidgetSuffix],
                        (this.options.data || {})[item.name + paramBindingsSuffix]);
                }
            });

            this.options.designer?.onLoad && this.options.designer.onLoad();

            this.element.on('click', 'a.show-on-widget', (e) => {
                var link = $(e.currentTarget);
                setShowOnWidgetChecked(link, !link.hasClass('is-checked'));
            });

            this.element.on('click', 'a.edit-param-binding', (e) => {
                var value = $(e.currentTarget).attr('data-value');
                new Matrix.PromptDialog({
                    title: "Edit Binding",
                    message: "Enter a binding key, or leave empty to clear binding",
                    editorType: Serenity.SelectEditor,
                    editorOptions: <Serenity.SelectEditorOptions>{
                        items: this.options.getBindingKeys ? this.options.getBindingKeys() : [],
                        autoComplete: true
                    },
                    required: false,
                    value: value,
                    validateValue: v => {
                        v = Q.trimToNull(v);
                        setParamBindingValue($(e.currentTarget), v);
                        return true;
                    }
                }).dialogOpen();
            });
        }

        destroy() {
            if (this.options?.designer != null) {
                this.options.designer.destroy();
                this.options.designer = null;
            }
            super.destroy();
        }

        protected getPropertyItems() {
            var items = (this.options.propertyItems || this.options.widgetTypeItem?.Options || []).slice();

            if (!Q.any(items, x => x.name == "Title")) {
                items.push({
                    name: 'Title',
                    title: 'Title',
                    editorType: 'String'
                });
            }

            if (!Q.any(items, x => x.name == "TitleLinkUrl")) {
                items.push({
                    name: 'TitleLinkUrl',
                    title: 'Title Link Url',
                    editorType: 'Matrix.UrlEditor'
                });
            }

            if (!Q.any(items, x => x.name == "Collapsible")) {
                items.push({
                    name: 'Collapsible',
                    title: 'Collapsible',
                    editorType: 'Boolean'
                });
            }

            return items;
        }

        protected getSaveEntity() {
            var entity = super.getSaveEntity();
            for (var key in this.parameterProps) {
                var props = this.parameterProps[key];
                if (props) {
                    entity[key + paramValuesSuffix] = props.save();
                    var paramsOnWidget = [];
                    var paramBindings: Q.Dictionary<string> = Object.create(null);
                    props.enumerateItems((item, widget) => {
                        if (!widget)
                            return;

                        var field = widget.getGridField();
                        if (field.find('.show-on-widget.is-checked').length)
                            paramsOnWidget.push(item.name);

                        var binding = field.find('.edit-param-binding').attr('data-value');
                        if (binding && binding.length)
                            paramBindings[item.name] = binding;
                    });
                    if (paramsOnWidget.length)
                        entity[key + paramsOnWidgetSuffix] = paramsOnWidget;
                    if (Object.keys(paramBindings).length)
                        entity[key + paramBindingsSuffix] = paramBindings;
                }
            }
            return entity;
        }

        protected okClickValidated() {
            this.onOkClick(this.getSaveEntity());
        }

        onOkClick: (data: any) => void;

        getEditor<TWidget = Serenity.Widget<any>>(property: string, widgetType: { new(...args: any[]): TWidget; }): TWidget {
            return this.byId(property).getWidget<TWidget>(widgetType);
        }

        getDatasetEditor(property?: string): Serenity.ServiceLookupEditor {
            return this.getEditor(property ?? "DatasetCode", Serenity.ServiceLookupEditor);
        }

        getDatasetCode(property?: string): string {
            return this.getDatasetEditor(property).value;
        }

        getDatasetColumns(then: (columns: Data.DataColumn[]) => void, property?: string): boolean {
            var datasetCode = this.getDatasetCode(property);
            if (!datasetCode)
                return false;

            WidgetDesignerDialog.listDatasetColumns(datasetCode, then);
            return true;
        }

        getDialogOptions() {
            var opt = super.getDialogOptions();
            opt.width = "950";
            return opt;
        }

        static listDatasetColumns(datasetCode: string, then: (columns: Data.DataColumn[]) => void) {
            var parameters: Q.Dictionary<string> = {};
            var listColumns = () => {
                DatasetService.ListColumns({
                    DatasetCode: datasetCode,
                    Parameters: parameters
                }, response => {
                    then(response.Columns);
                }, {
                    onError: (response: Serenity.ServiceResponse) => {
                        if (response && response.Error && response.Error.Code == "MISSING_PARAMETER_VALUES") {
                            var paramList = JSON.parse(response.Error.Arguments) as Data.DataParameter[];
                            var dlg = new Data.StoredProcParametersDialog();
                            dlg.setParameters(paramList);
                            dlg.okClick = () => {
                                parameters = dlg.getParameterValues();
                                dlg.dialogClose();
                                listColumns();
                            };
                            dlg.dialogOpen();
                        }
                    }
                });
            };

            listColumns();
        }

        private parameterProps: { [key: string]: Serenity.PropertyGrid } = {};

        private initParameterProps(key: string, value?: any, paramsOnWidget?: string[], paramBindings?: Q.Dictionary<string>) {

            var el: JQuery;
            var propGrid = this.parameterProps[key];
            if (propGrid) {
                el = propGrid.element;
                propGrid.destroy();
                delete this.parameterProps[key];
                el.html('');
            }
            else
                el = $('<div/>').insertAfter(this.propertyGrid.element);

            var datasetEl = this.byId(key);
            datasetEl.closest('.field').nextAll('.ds-prop-field').remove();
            var datasetEditor = datasetEl.tryGetWidget(Serenity.Select2Editor);
            var datasetCode = datasetEditor?.value;
            if (!datasetCode)
                return;

            DatasetService.ListParameters({
                DatasetCode: datasetCode,
            },
                response => {
                    if (!response.Parameters ||
                        !response.Parameters.length)
                        return;

                    var items = response.Parameters;

                    for (var i = items.length - 1; i >= 0; i--) {
                        var item = items[i];
                        if (item.editorType == 'Matrix.DateRangeEditor' &&
                            item.editorParams &&
                            item.editorParams.rangeEndProperty) {
                            var endIdx = Q.indexOf(items, x => x.name == item.editorParams.rangeEndProperty);
                            if (endIdx >= 0)
                                items.splice(endIdx, 1);
                        }
                    }

                    this.parameterProps[key] = propGrid = new Serenity.PropertyGrid(el, {
                        items: items,
                        mode: Serenity.PropertyGridMode.insert,
                        idPrefix: this.idPrefix + "DSParams_"+ key + "_"
                    });

                    propGrid.element.find('div.field')
                        .addClass('ds-prop-field')
                        .insertAfter(datasetEl.closest(".field"));

                    propGrid.load(value || {});

                    propGrid.enumerateItems((item, editor) => {
                        var pb = $(`<a class="edit-param-binding" title="add binding">
                            <i class="ni ni-link"></i></a>`)
                            .insertBefore(editor.getGridField().children('div.vx'));

                        if (paramBindings && !Q.isTrimmedEmpty(paramBindings[item.name]))
                            setParamBindingValue(pb, paramBindings[item.name]);

                        var sow = $(`<a class="show-on-widget" title="Show on widget">
<i class="ni ni-square"></i></a>`)
                            .insertAfter(pb);
                            
                        if (paramsOnWidget && paramsOnWidget.indexOf(item.name) >= 0)
                            setShowOnWidgetChecked(sow, true);

                    });
                });
        }

    }

    function setShowOnWidgetChecked(link: JQuery, checked: boolean) {
        link.toggleClass('is-checked', !!checked)
            .children('i')
            .toggleClass('ni-square', !checked)
            .toggleClass('ni-check-round-cut', !!checked);
    }

    function setParamBindingValue(link: JQuery, value: string) {
        var hasBinding = !!(value && value.length);
        link.toggleClass('has-binding', hasBinding)
            .attr('data-value', Q.trimToNull(value) ?? null)
            .attr('title', hasBinding ? ('edit binding: ' + Q.trimToEmpty(value)) : 'add binding')
            .children('i')
            .toggleClass('ni-unlink', hasBinding)
            .toggleClass('ni-link', !hasBinding);
    }
}